// Утилиты для генерации ссылок на биржи

/**
 * Генерирует ссылку на торговую пару на бирже
 * @param {string} exchange - название биржи (mexc, gate, bingx, bitget, bybit, kucoin)
 * @param {string} type - тип торговли (spot, futures)
 * @param {string} symbol - полный символ (например, PEPEUSDT)
 * @param {string} baseSymbol - базовый символ (например, PEPE)
 * @returns {string} URL на биржу
 */
export function generateExchangeUrl(exchange, type, symbol, baseSymbol) {
  const cleanSymbol = baseSymbol || symbol.replace(/[-_]?USDT.*$/i, '');

  const urls = {
    mexc: {
      spot: `https://www.mexc.com/exchange/${cleanSymbol}_USDT`,
      futures: `https://futures.mexc.com/exchange/${cleanSymbol}_USDT`
    },
    gate: {
      spot: `https://www.gate.io/trade/${cleanSymbol}_USDT`,
      futures: `https://www.gate.io/futures_trade/USDT/${cleanSymbol}_USDT`
    },
    bingx: {
      spot: `https://bingx.com/en-us/spot/${cleanSymbol}USDT`,
      futures: `https://bingx.com/en-us/swap/${cleanSymbol}-USDT`
    },
    bitget: {
      spot: `https://www.bitget.com/spot/${cleanSymbol}USDT_SPBL`,
      futures: `https://www.bitget.com/futures/usdt/${cleanSymbol}USDT`
    },
    bybit: {
      spot: `https://www.bybit.com/trade/spot/${cleanSymbol}/USDT`,
      futures: `https://www.bybit.com/trade/usdt/${cleanSymbol}USDT`
    },
    kucoin: {
      spot: `https://www.kucoin.com/trade/${cleanSymbol}-USDT`,
      futures: `https://www.kucoin.com/futures/trade/${cleanSymbol}USDTM`
    }
  };

  return urls[exchange]?.[type] || '#';
}

/**
 * Получает отображаемое название биржи
 * @param {string} exchange - код биржи
 * @returns {string} читаемое название
 */
export function getExchangeDisplayName(exchange) {
  const names = {
    mexc: 'MEXC',
    gate: 'Gate.io',
    bingx: 'BingX',
    bitget: 'Bitget',
    bybit: 'Bybit',
    kucoin: 'KuCoin'
  };

  return names[exchange] || exchange.toUpperCase();
}